import { L2RestoDetailsComponent } from './../pages/l2-resto-details/l2-resto-details.component';
import { ClaimBuisnessComponent, FinalPopupComponent, RestoClaimDetailsComponent } from './../pages/claim-buisness/claim-buisness.component';
import { ViewRestoComponent } from './../pages/view-resto/view-resto.component';
import { D2AllRestoComponent } from '../pages/d2-all-resto/d2-all-resto.component'
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth-guard/auth-guard';
import { VerticalLayoutComponent } from '../layout/vertical';
import { HorizontalLayoutComponent } from '../layout/horizontal';
import { PublicLayoutComponent } from '../layout/public';
import { Page404Component } from '../pages/page-404';
import { MainPageComponentnt } from '../pages/main';
import { PageSignInComponent } from '../pages/sign-in';
import { ForgotPasswordComponent } from '../pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../pages/reset-password/reset-password.component';
import { MainAnalyticsPageComponentnt } from '../pages/main-analytics';
import { RestaurantSettingComponent } from '../pages/restaurant-setting/restaurant-setting.component';
import { RestaurantTablesComponent } from '../pages/restaurant-tables/restaurant-tables.component';
import { CustomlayoutComponent } from '../layout/customlayout/customlayout.component';
import { DineinordersComponent } from '../pages/dineinorders/dineinorders.component';
import { AboutrestoComponent } from '../pages/aboutresto/aboutresto.component';
import { AddonComponent } from '../pages/addon/addon.component';
import { RestaurantlistsComponent } from '../pages/restaurantlists/restaurantlists.component';
import { SuperadmindashboardComponent } from '../pages/superadmindashboard/superadmindashboard.component';
import { AccountsettingComponent } from '../pages/accountsetting/accountsetting.component';
import { AllergensdietaryComponent } from '../pages/allergensdietary/allergensdietary.component';
import { CategorycuisineComponent } from '../pages/categorycuisine/categorycuisine.component';
import { SuperHorizonComponent } from '../layout/super-horizon/super-horizon.component';
import { NutrilabelDashboardComponent } from '../pages/nutrilabel-dashboard/nutrilabel-dashboard.component';
import { WeeklyTopComponent } from '../pages/weekly-top/weekly-top.component';
import { MasterRestaurantComponent } from '../pages/master-restaurant/master-restaurant.component';
import { ClaimQrCodeComponent } from '../pages/claim-qr-code/claim-qr-code.component';
import { EmailTemplateComponent } from '../pages/email-template/email-template.component';
import { RegulatoryAndEventPlanComponent } from '../pages/regulatory-and-event-plan/regulatory-and-event-plan.component';

const VERTICAL_ROUTES: Routes = [
  { path: 'main', component: MainPageComponentnt },
  { path: 'analytics', component: MainAnalyticsPageComponentnt },
  { path: 'orders', component: DineinordersComponent },
  { path: 'addon', component: AddonComponent },
  { path: '**', component: Page404Component }
];

const PUBLIC_ROUTES: Routes = [
  { path: 'sign-in', component: PageSignInComponent },
  { path: 'forgot', component: ForgotPasswordComponent },
  { path: 'resetPassword', component: ResetPasswordComponent },
];

const CUSTOM_ROUTES: Routes = [
  { path: 'restaurantSetting', component: RestaurantSettingComponent },
  { path: 'restaurantTables', component: RestaurantTablesComponent },
  { path: 'aboutrestaurant', component: AboutrestoComponent },

];
const SUPERADMIN_ROUTES: Routes = [
  { path: 'restolist', component: RestaurantlistsComponent },
  { path: 'dashboard', component: SuperadmindashboardComponent },
  { path: 'accountSetting', component: AccountsettingComponent },
  { path: 'emailTemplate', component: EmailTemplateComponent },
  { path: 'regulatoryAndPlan', component: RegulatoryAndEventPlanComponent },
  { path: 'allergensDietary', component: AllergensdietaryComponent },
  { path: 'categoryCuisines', component: CategorycuisineComponent },
  { path: 'd2restolist', component: D2AllRestoComponent },
  { path: 'nutri-label', component: NutrilabelDashboardComponent },
  { path: 'weeklyUpdate', component: WeeklyTopComponent }
]
const VIEWRESTO_ROUTES: Routes = [
  { path: 'viewresto', component: ViewRestoComponent },
  { path: 'main', component: MainPageComponentnt },
  { path: 'analytics', component: MainAnalyticsPageComponentnt },
  { path: 'orders', component: DineinordersComponent },
  { path: 'addon', component: AddonComponent },
  { path: '**', component: Page404Component }
]
const CLAIM_ROUTES: Routes = [
  { path: 'claim', component: ClaimBuisnessComponent },
  { path: 'qr', component: ClaimQrCodeComponent },
  { path: 'successupdate', component: FinalPopupComponent },
  { path: 'successclaim', component: RestoClaimDetailsComponent }
]
const RESTO_L2_DETAILS: Routes = [
  { path: 'restoDetails', component: L2RestoDetailsComponent },
  { path: 'masterRestoDetails', component: MasterRestaurantComponent },

]
export const ROUTES: Routes = [
  {
    path: '',
    redirectTo: '/public/sign-in',
    pathMatch: 'full'
  },
  {
    path: 'vertical',
    component: VerticalLayoutComponent,
    children: VERTICAL_ROUTES
  },
  {
    path: 'horizontal',
    component: HorizontalLayoutComponent,
    children: VERTICAL_ROUTES,
    canActivate: [AuthGuard]
  },
  {
    path: 'admin',
    component: SuperHorizonComponent,
    children: VIEWRESTO_ROUTES,
    canActivate: [AuthGuard]
  },
  {
    path: 'configration',
    component: CustomlayoutComponent,
    children: CUSTOM_ROUTES,
    canActivate: [AuthGuard]
  },
  {
    path: 'superadmin',
    // component: PublicLayoutComponent,
    children: SUPERADMIN_ROUTES,
    canActivateChild: [AuthGuard]
  },
  {
    path: 'business',
    children: CLAIM_ROUTES,
  },
  {
    path: 'public',
    component: PublicLayoutComponent,
    children: PUBLIC_ROUTES
  },
  {
    path: 'details',
    children: RESTO_L2_DETAILS,
    canActivate: [AuthGuard]

  },
  {
    path: '**',
    component: VerticalLayoutComponent,
    children: VERTICAL_ROUTES
  }
];

@NgModule({
  imports: [

  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class RoutingModule { }
